import PasswordUpdatePage from './PasswordUpdatePage';
export default PasswordUpdatePage;